const LAST_ROUTE_KEY = "last_route"

export interface LastRoute {
  route: string
  type: "pay" | "cart"
}

export const saveLastRoute = (route: LastRoute) => {
  try {
    localStorage.setItem(LAST_ROUTE_KEY, JSON.stringify(route))
  } catch (error) {
    console.error("Error guardando la ruta:", error)
  }
}

export const getLastRoute = (): LastRoute | null => {
  try {
    const item = localStorage.getItem(LAST_ROUTE_KEY)
    return item ? (JSON.parse(item) as LastRoute) : null
  } catch (error) {
    console.error("Error recuperando la ruta:", error)
    return null
  }
}

export const clearLastRoute = () => {
  try {
    localStorage.removeItem(LAST_ROUTE_KEY)
  } catch (error) {
    console.error("Error limpiando la ruta:", error)
  }
}
